import React, { useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../css/footerUsa.css";
import { ActualLangContext } from "../../contexts/ActualLangContext";
import SocialLinks from "./SocialLinks";

const LEGACY_FOOTER_DESCRIPTOR =
  "Possumus: Microsoft Solutions Partner. Software engineering, cloud engineering, staff augmentation and ITaaS. Agile, innovation and human value.";
const UPDATED_FOOTER_DESCRIPTOR =
  "Possumus: Microsoft Solutions Partner. AI-augmented software, cloud, data, and nearshore engineering teams for organizations across the Americas.";

const normalizeFooterText = (text, lang) => {
  if (lang === "en" && text === LEGACY_FOOTER_DESCRIPTOR) {
    return UPDATED_FOOTER_DESCRIPTOR;
  }
  return text;
};

const FooterUsaMobile = ({ logoPossumus, logoIso, options }) => {
  let newDate = new Date();
  let year = newDate.getFullYear();
  const { actualLang } = useContext(ActualLangContext);
  return (
    <Container fluid id="footer">
      <Container className="containerFooterMobile">
        {/* Sección de menús de navegación */}
        <Row className="justify-content-center footer-nav-section-mobile">
          {options?.map((option, idx) => (
            <Col key={idx} sm={6} className="col-menu-footer">
              <p className="titleFooter">
                {normalizeFooterText(option.title, actualLang)}
              </p>
              {option.multipleOptions.data?.length > 0 &&
                option.multipleOptions.data.map((multipleOption, index) => (
                  <p key={index}>
                    <a
                      href={
                        multipleOption.attributes.href.includes("https") ||
                        multipleOption.attributes.href.includes("#") ||
                        multipleOption.attributes.href === "/solutions" ||
                        multipleOption.attributes.href === "/soluciones"
                          ? multipleOption.attributes.href
                          : `/${actualLang === "en" ? "en-en" : "es-es"}${
                              multipleOption.attributes.href
                            }`
                      }
                    >
                      {normalizeFooterText(
                        multipleOption.attributes.title,
                        actualLang
                      )}
                    </a>
                  </p>
                ))}
            </Col>
          ))}
        </Row>
        
        {/* Sección de logos centrados */}
        <Row className="footer-logos-section-mobile justify-content-center">
          <Col xs={7} className="text-center">
            <a href="/">
              <img
                src={logoPossumus}
                alt="Possumus"
                className="img-fluid logoPossumus"
                loading="lazy"
              ></img>
            </a>
          </Col>
          <Col xs={7} className="text-center">
            <div
              className="clutch-widget justify-content-center d-flex align-items-center"
              data-url="https://widget.clutch.co"
              data-widget-type="2"
              data-height="45"
              data-nofollow="true"
              data-expandifr="true"
              data-primary-color="#fcd702"
              data-secondary-color="#fcd702"
              data-clutchcompany-id="1572791"
            ></div>
          </Col>
          <Col xs={7} className="col-iso text-center">
            <img
              src={logoIso}
              alt="ISO Certification"
              className="img-fluid logoIso"
              loading="lazy"
            ></img>
          </Col>
        </Row>
        
        {/* FILA 3: Copyright y redes sociales */}
        <Row className="footer-bottom-row">
          <Col xs="12" className="footer-copyright">
            <p>Copyright © {year} Possumus. All Rights Reserved.</p>
          </Col>
          <Col xs="12" className="footer-social">
            <SocialLinks title="Join Us" />
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default FooterUsaMobile;
